module.exports = __webpack_public_path__ + "img/T08.1b160995.jpg";